<template>
  <div style="background-color: transparent;">
    <div class="bubble-clock-container">
        <div id="bubbleclock" class="clock-previewca bubblefont" :style="bubbleStyle">
            <span class="bubbletime"><p class="bubbleampm">{{ ampm }}</p>{{ hours }}:{{ minutes }}</span>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "app",
  data() {
    const params = this.getParamsFromQuery();
    return {
      hours: "",
      minutes: "",
      ampm: "",
      clipPath: params.clipPath,
      customColor1: params.color1,
      customColor2: params.color2,
      customColor3: params.color3,
      gradientAngle: params.angle,
    };
  },

  computed: {
    gradientBackground: function() {
      if (this.customColor3) {
        return `linear-gradient(${this.gradientAngle}deg, ${this.customColor1} 0%, ${this.customColor3} 46%, ${this.customColor2} 100%)`;
      }
      return `linear-gradient(${this.gradientAngle}deg, ${this.customColor1} 0%, ${this.customColor2} 100%)`;
    },
    bubbleStyle: function() {
      return {
        clipPath: this.clipPath,
        background: this.gradientBackground,
        backgroundSize: '180% 180%',
        animation: 'custom-gradient-animation 12s ease infinite'
      };
    },
  },
  mounted: function () {
    this.updateTime();
    setInterval(this.updateTime, 1000);
  },
  methods: {
    getParamsFromQuery: function() {
      // デフォルト値
      const defaults = {
        clipPath: `path("${this.generateBubblePath(3, 0.12, 130, 1234)}")`,
        color1: '#0093E9',
        color2: '#80D0C7',
        color3: '',
        angle: 260
      };
      
      // URLパラメータからshapeを取得
      let shapeParam = this.$route.query.shape;
      
      if (!shapeParam) {
        return defaults;
      }
      
      try {
        // URLデコード
        if (shapeParam.includes('%')) {
          shapeParam = decodeURIComponent(shapeParam);
        }
        
        // Base64デコード
        const decoded = window.atob(shapeParam);
        const params = JSON.parse(decoded);
        
        const result = { ...defaults };
        
        if (params.waves && params.softness !== undefined && params.size) {
          const seed = params.seed || 1234;
          const path = this.generateBubblePath(params.waves, params.softness, params.size, seed);
          result.clipPath = `path("${path}")`;
        }
        
        if (params.color1) {
          result.color1 = params.color1;
        }
        if (params.color2) {
          result.color2 = params.color2;
        }
        if (params.color3) {
          result.color3 = params.color3;
        }
        if (params.angle !== undefined) {
          result.angle = params.angle;
        }
        
        return result;
      } catch (e) {
        console.error('Failed to decode shape parameter:', e);
        return defaults;
      }
    },
    generateBubblePath: function(waves, softness, size, seed) {
      // waves: 波の数（2-5推奨）- 少ないほどシンプルで丸い形状
      // softness: 柔らかさ（0.05-0.25推奨）- 小さいほど円に近い
      // size: ベースの半径（80-120推奨）
      // seed: ランダムシード（決定論的な生成のため）
      
      const numWaves = waves || 3;
      const deformation = softness || 0.12;
      const radius = size || 130;
      const centerX = 200; // 要素の中心（400px / 2）
      const centerY = 200; // 要素の中心（400px / 2）
      
      // シンプルな疑似乱数生成器（シードベース）
      let randomSeed = seed || Math.floor(Math.random() * 10000);
      const random = () => {
        randomSeed = (randomSeed * 9301 + 49297) % 233280;
        return randomSeed / 233280;
      };
      
      // 各波形のパラメータを生成（低周波のsin波）
      const waveParams = [];
      for (let i = 0; i < numWaves; i++) {
        waveParams.push({
          frequency: i + 2, // 周波数（2, 3, 4, ...）- 低周波で滑らか
          amplitude: (random() * 0.6 + 0.4) * deformation * radius / numWaves, // 振幅
          phase: random() * Math.PI * 2 // 位相
        });
      }
      
      // 点を生成（多めに取って滑らかに）
      const numPoints = 64;
      const pathPoints = [];
      
      for (let i = 0; i < numPoints; i++) {
        const angle = (i / numPoints) * Math.PI * 2;
        let currentRadius = radius;
        
        // 各波形の影響を加算（滑らかな変形）
        for (const wave of waveParams) {
          currentRadius += Math.sin(angle * wave.frequency + wave.phase) * wave.amplitude;
        }
        
        const x = centerX + Math.cos(angle) * currentRadius;
        const y = centerY + Math.sin(angle) * currentRadius;
        
        pathPoints.push({ x, y });
      }
      
      // SVG pathを生成（Catmull-Romスプラインでスムーズな曲線）
      let path = `M ${pathPoints[0].x.toFixed(2)} ${pathPoints[0].y.toFixed(2)}`;
      
      for (let i = 0; i < pathPoints.length; i++) {
        const p0 = pathPoints[(i - 1 + pathPoints.length) % pathPoints.length];
        const p1 = pathPoints[i];
        const p2 = pathPoints[(i + 1) % pathPoints.length];
        const p3 = pathPoints[(i + 2) % pathPoints.length];
        
        // Catmull-Rom to Bezier変換
        const tension = 6; // テンションが高いほど滑らか
        const cp1x = p1.x + (p2.x - p0.x) / tension;
        const cp1y = p1.y + (p2.y - p0.y) / tension;
        const cp2x = p2.x - (p3.x - p1.x) / tension;
        const cp2y = p2.y - (p3.y - p1.y) / tension;
        
        path += ` C ${cp1x.toFixed(2)} ${cp1y.toFixed(2)}, ${cp2x.toFixed(2)} ${cp2y.toFixed(2)}, ${p2.x.toFixed(2)} ${p2.y.toFixed(2)}`;
      }
      
      path += ' Z';
      
      return path;
    },
    updateTime: function () {
      let currentdate = new Date();
      let hours = currentdate.getHours();
      this.ampm = hours >= 12 ? 'pm' : 'am';
      hours = hours % 12;
      hours = hours ? hours : 12; // 0時は12時として扱う
      this.hours = this.zeroPadding(hours, 2);
      this.minutes = this.zeroPadding(currentdate.getMinutes(), 2);
    },
    zeroPadding: function (num, len) {
      let zero = "";

      // 0の文字列を作成
      for (var i = 0; i < len; i++) {
        zero += "0";
      }

      // zeroの文字列と、数字を結合し、後ろ２文字を返す
      return (zero + num).slice(-len);
    },
  },
};
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Outfit:wght@100..900&display=swap');

p {
  margin: 0;
  padding: 0;
  font-size: 14px;
}

.content-title{
  text-align: center;
}

h2{
  position: relative;
  display: inline-block;
  padding: 0 65px;
  text-align: center;
  letter-spacing: 1px
}

h2:before,
h2:after {
  position: absolute;
  top: calc(50% - 3px);
  width: 50px;
  height: 6px;
  content: '';
  border-top: solid 2px #000;
  border-bottom: solid 2px #000;
}

h2:before {
  left: 0;
}

h2:after {
  right: 0;
}

h3{
  font-size: 14px;
  margin-top: 24px;
}

.main{
  max-width: 514px;
  margin: 0 auto;
}

#bubbleclock {
  width: 400px;
  height: 400px;
  /* clip-pathは動的に適用される */
  color: #fff;
  white-space: nowrap;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) translateZ(0);
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  filter: drop-shadow(0 0 0.5px rgba(255, 255, 255, 0.3));
}

.bubble-clock-container {
  width: 400px;
  height: 400px;
  position: relative;
}

.bubbletime {
  letter-spacing: 0.05em;
  font-size: 62px;
  line-height: 0.75em;
  margin-bottom: 10px;
}

.bubbleampm {
  font-size: 0.5em;
  vertical-align: 2px;
  margin-left: auto;
  margin-right: 0;
  display: flex;
  justify-content: flex-end;
}


.set{
  padding: 8px 12px 24px 12px;
  margin-top: 24px;
  background-color: #f9f3e9;
}

.select-gradation{
  text-align: center;
  background-color: aliceblue;
  width: -moz-fit-content;
  width: fit-content;
  margin: 0 auto;
  padding: 24px 24px 12px 24px;
  line-height: 1;
  border-radius: 10px;
  margin-right: 12px;
}


.blue-gradient-background {
  background: linear-gradient(260deg,#FBDA61 0%, #FF5ACD 100%);
  background-size: 180% 180%;
  animation: blue-gradient-animation 10s ease infinite;
}

@keyframes blue-gradient-animation {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

.red-gradient-background {
  background: linear-gradient(43deg,#4158D0 0%, #C850C0 46%, #FFCC70 100%);
  background-size: 180% 180%;
  animation: red-gradient-animation 6s ease infinite;
}

@keyframes red-gradient-animation {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
.green-gradient-background {
  background: linear-gradient(256deg,#0093E9 0%,#a1efc6 46%, #80D0C7 100%);
  background-size: 240% 240%;
  animation: green-gradient-animation 10s ease infinite;
}

@keyframes green-gradient-animation {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

.sky-gradient-background {
  background: linear-gradient(260deg, #D9AFD9 0%, #97D9E1 100%);
  background-size: 240% 240%;
  animation: sky-gradient-animation 12s ease infinite;
}

@keyframes sky-gradient-animation {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

.gray-gradient-background {
  background: linear-gradient(260deg, #304352 0%, #d7d2cc 100%);
  background-size: 240% 240%;
  animation: gray-gradient-animation 12s ease infinite;
}

@keyframes gray-gradient-animation {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

.yellow-gradient-background {
  background: linear-gradient(260deg, #F3F9A7 0%, #CAC531 100%);
  background-size: 240% 240%;
  animation: yellow-gradient-animation 12s ease infinite;
}

@keyframes yellow-gradient-animation {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

.lush-gradient-background {
  background: linear-gradient(260deg, #56ab2f 0%, #a8e063 100%);
  background-size: 240% 240%;
  animation: lush-gradient-animation 12s ease infinite;
}

@keyframes lush-gradient-animation {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

.moon-gradient-background {
  background: linear-gradient(260deg, #4e54c8 0%, #8f94fb 100%);
  background-size: 240% 240%;
  animation: moon-gradient-animation 12s ease infinite;
}

@keyframes moon-gradient-animation {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

.rose-gradient-background {
  background: linear-gradient(260deg, #f4c4f3 0%, #fc67fa 100%);
  background-size: 240% 240%;
  animation: rose-gradient-animation 12s ease infinite;
}

@keyframes rose-gradient-animation {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

.steel-gradient-background {
  background: linear-gradient(260deg, #1F1C2C 0%, #928DAB 100%);
  background-size: 240% 240%;
  animation: steel-gradient-animation 12s ease infinite;
}

@keyframes steel-gradient-animation {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

.bubblefont{
  font-family: "Outfit", sans-serif;
  font-optical-sizing: auto;
  font-weight: 500;
  font-style: normal;
}

.radio-main{
  display: -webkit-flex;
  display: flex;
  margin-top:12px;
}
.m-form-text{
  height: 2.4em;
  padding: 0 16px;
  border-radius: 4px;
  border: none;
  box-shadow: 0 0 0 1px #ccc inset;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}

@keyframes custom-gradient-animation {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

</style>
